// @flow

export const PAGE_CHECKOUT: 'checkout' = 'checkout';
export const PAGE_CONFIRM: 'confirm' = 'confirm';
export const ROUTES = {
  checkoutPage: '/:journeyId',
  confirmPage: '/confirmation/:journeyId',
};

export const TRAVEL_TYPE_PACKAGE_TOUR: 'packageTour' = 'packageTour';
export const TRAVEL_TYPE_OWN_ARRIVAL: 'ownArrival' = 'ownArrival';

export const INVIA_TYPE_GROUP_PROMOTION: 'IT08P' = 'IT08P';
export const INVIA_TYPE_GROUP_FLEX: 'IT08F' = 'IT08F';
export const INVIA_TYPE_GROUP_SAFETY: 'IT08S' = 'IT08S';

export const INVIA_TYPE_CAN_INCLUDED: 'IT08F-CAN#FEE#FEIN' =
  'IT08F-CAN#FEE#FEIN';
export const INVIA_TYPE_CAN_EXCLUDED: 'IT08F-CAN#FEE#FEE' = 'IT08F-CAN#FEE#FEE';
export const INVIA_TYPE_CAN_FREE: 'IT08F-CAN#FREE' = 'IT08F-CAN#FREE';
export const INVIA_TYPE_RES_INCLUDED: 'IT08F-RES#INC' = 'IT08F-RES#INC';
export const INVIA_TYPE_RES_EXCLUDED: 'IT08F-RES#EXC' = 'IT08F-RES#EXC';

export const INVIA_TYPE_SWIM_UP_POOL: 'IT05-PO#SUP' = 'IT05-PO#SUP';
export const INVIA_TYPE_PRIVATE_POOL: 'IT05-PO#PP' = 'IT05-PO#PP';
export const INVIA_TYPE_PRIVATE_HOT_TUB: 'IT05-WP#PW' = 'IT05-WP#PW';
export const INVIA_TYPE_BALCONY_TERRACE: 'IT05-BT#BT' = 'IT05-BT#BT';
export const INVIA_TYPE_BALCONY: 'IT05-BT#BA' = 'IT05-BT#BA';
export const INVIA_TYPE_TERRACE: 'IT05-BT#TE' = 'IT05-BT#TE';
export const INVIA_TYPE_FREE_WIFI: 'IT05-IN#FW' = 'IT05-IN#FW';
export const INVIA_TYPE_BARRIER_FREE: 'IT05-DF#DF' = 'IT05-DF#DF';
export const INVIA_TYPE_OCEAN_VIEW_PART: 'IT13-SEVI#PART' = 'IT13-SEVI#PART';
export const INVIA_TYPE_OCEAN_VIEW: 'IT13-SEVI#SEVI' = 'IT13-SEVI#SEVI';

export const EXPEDIA_TYPE_GROUP_FLEX: 'EPS#' = 'EPS#';
export const EXPEDIA_TYPE_CANCELLATION_RULE_NOT_REFUNDABLE: 'EPS#REF#NONE' =
  'EPS#REF#NONE';
export const EXPEDIA_TYPE_CANCELLATION_RULE_PARTIAL_REFUNDABLE: 'EPS#REF' =
  'EPS#REF';
export const EXPEDIA_TYPE_CANCELLATION_RULE_REFUNDABLE: 'EPS#REF#FULL' =
  'EPS#REF#FULL';

export const BDV_SPLIT: 'FBO_1938_bdv_inactive' = 'FBO_1938_bdv_inactive';
export const EXIT_LAYER_SPLIT: 'FBO_2656_split_exit_layer' =
  'FBO_2656_split_exit_layer';
export const CUSTOMER_LOGIN_SPLIT = 'FBO_2379_customer_login';
export const VOUCHERBANNER_INACTIVE_SPLIT: 'FBO_2825_voucherbanner_inactive' =
  'FBO_2825_voucherbanner_inactive';
export const SOVENDUS_SPLIT: 'FBO_2815_sovendus_widget' =
  'FBO_2815_sovendus_widget';
export const BESTPRICE_BANNER_SPLIT = 'FBO_2903_bestprice_banner';
export const STATICSCARCITY_ELEMENT_SPLIT =
  'FBO_2919_static_scarcity_elements_IBE4_5';
export const DYNAMICSCARCITY_ELEMENT_SPLIT =
  'FBO_3328_dynscarcity_offerlist_checkout';
export const CASHBACK_VOUCHER_BANNER_600_SPLIT =
  'FBO_3029_cashback_voucher_banner_600';
export const CASHBACK_VOUCHER_BANNER_500_SPLIT =
  'FBO_3282_cashback_voucher_banner_500';
export const CASHBACK_VOUCHER_BANNER_SPLIT =
  'FBO_3177_cashback_voucher_banner_200';
export const PRICECACHE_SPLIT = 'FBO_2956_price_cache';
export const ENABLED_CTA_SPLIT = 'FBO_3264_enabledCTA';
export const LOGIN_NEEDED_SPLIT = 'FBO_3376_login_needed';
export const LEAD_GENERATION_SPLIT = 'FBO_3802_lead_generation';
export const AMA_RECOMMENDATION_PERCENTAGE_SPLIT =
  'FFP_5186_ama_recommendation_percentage';
export const AI_REVIEW_SUMMARY_SPLIT = 'FBO_3647_review_AIsummary';
export const NATIONALITY_SPLIT = 'FBO_3323_nationality_dropdown';
export const SOI_SWITCH_SPLIT = 'FBO_3569_soi_switch';
export const PAYPAL_SPLIT = 'FBO_3463_paypal';
export const TO_VOUCHER_SPLIT = 'FBO_3454_TOvoucher';
export const SUGGESTED_VOUCHER_SPLIT = 'FBO_3298_suggestedvoucher';
export const HIDE_PARTNER_RECOMMENDATION_SPLIT =
  'FBO_3648_hide_partner_recommendation';
export const HIDE_CONFIRMPAGE_VOUCHER_SECTION_SPLIT =
  'FBO_3648_hide_confirmpage_voucher_section';

export const PRICECACHE_MIN_THRESHOLD = 5;
export const DYNAMICSCARCITY_ELEMENT_THRESHOLD = 10;

export const LOCALSTORAGE_LOGIN_SECTION = 'loginSectionDismissedAt';

export const CUSTOMER_IS_TRAVELER_CHECKBOX = 'customerIsTraveler';

export const SECTION_PAYMENT = 'section-payment';

export const PAYPAL_PARAM: 'paypal' = 'paypal';
export const PAYPAL_SUCCESS: 'success' = 'success';
export const PAYPAL_CANCEL: 'cancel' = 'cancel';
export const PAYPAL_PENDING: 'pending' = 'pending';
export const PAYPAL_MISSING_AUTHORIZATION: string =
  'Paypal authorization missing.';

export const VIRTPATH_AIDUDE = 'AiduDe';
export const VIRTPATH_AIDUAT = 'AiduAt';
export const VIRTPATH_AIDUCH = 'AiduCh';
export const VIRTPATH_REISENDE = 'ReisenDe';
export const VIRTPATH_REISENFLUEGE = 'ReisenFluegeDe';
export const VIRTPATH_REISEGEIERDE = 'ReisegeierDe';
export const VIRTPATH_REISEGEIERAT = 'ReisegeierAt';
export const VIRTPATH_REISEGEIERCH = 'ReisegeierCh';

export const LEAD_SECTION_CONSENT = 'leadSection';
